document.addEventListener("DOMContentLoaded", function () {
    // Select all 'submenu-item-heading' elements
    const headings = document.querySelectorAll('.submenu-item-heading');
    
    headings.forEach(heading => {
      // Add click event to show 'sidemenu-submenu'
      heading.addEventListener('click', function () {
        const submenu = this.nextElementSibling; // Get the next sibling (sidemenu-submenu)
        if (submenu && submenu.classList.contains('sidemenu-submenu')) {
          submenu.classList.add('visible'); // Add class to show
        }
      });
    });
  
    // Select all 'submenu-top' elements
    const tops = document.querySelectorAll('.submenu-top');
    
    tops.forEach(top => {
      // Add click event to hide 'sidemenu-submenu'
      top.addEventListener('click', function () {
        const submenu = this.parentElement; // Get the parent (sidemenu-submenu)
        if (submenu && submenu.classList.contains('sidemenu-submenu')) {
          submenu.classList.remove('visible'); // Remove class to hide
        }
      });
    });
  
      // Side menu show
      document.querySelector(".catelog_item").addEventListener("click", function() {
          const targetDiv = document.querySelector("#side_menu");
          if (targetDiv) {
              targetDiv.classList.add("show");
          }
      });
  
      // Side menu hide
      document.querySelector(".sidemenu-close").addEventListener("click", function() {
          console.log("Close button clicked"); // Debugging line 
          const targetDiv = document.querySelector(".side-menu");
          if (targetDiv) {
              targetDiv.classList.remove("show");
          }
      });
  
  });